import { css } from 'styled-components';

export const details = css`
  display: block;

  summary {
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    &::-webkit-details-marker {
      display: none;
    }
  }

  summary > div {
    flex-grow: 1;
  }

  summary > span {
    flex-grow: 0;
    transition: transform 0.5s;
  }

  &[open] summary > span {
    transform: rotate(0);
  }

  &:not([open]) summary > span {
    transform: rotate(180deg);
  }
`;
